import React from 'react';
import { FadeIn } from './FadeIn';
export function Section1() {
  return <section className="py-20 bg-ivory-dark px-6" data-id="element-110">
      <div className="max-w-3xl mx-auto text-center" data-id="element-111">
        <FadeIn data-id="element-112">
          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-10" data-id="element-113">
            EL MOMENTO DE VERDAD
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-114">
          <p className="text-2xl md:text-3xl font-serif text-dark mb-8 leading-snug" data-id="element-115">
            ¿Cuántas veces has sentido esa vergüenza silenciosa?
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-116">
          <p className="text-lg text-dark-light mb-6 leading-relaxed" data-id="element-117">
            Cuando el vendedor de autos revisa tu crédito y de repente su tono
            cambia. Cuando ves a otros latinos comprando su casa y tú sigues
            firmando contratos de renta cada año. Cuando trabajas 60 horas a la
            semana y aun así el banco te mira como si fueras un riesgo.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-118">
          <p className="text-xl font-medium text-dark mb-8" data-id="element-119">
            No es que no trabajes suficiente. No es que no seas suficiente.
            <br data-id="element-120" />
            <span className="text-gold mt-2 block" data-id="element-121">
              Es que nadie te ha enseñado las reglas del juego.
            </span>
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-122">
          <p className="text-lg text-dark-light mb-8 leading-relaxed" data-id="element-123">
            En Estados Unidos, el crédito no es un reflejo de tu valor como
            persona. Es un algoritmo. Y los algoritmos tienen reglas. Reglas
            escritas en leyes federales que los bancos prefieren que no
            conozcas, porque mientras no las conozcas, sigues pagando intereses
            de castigo, rentas que suben cada año y tasas de seguro diseñadas
            para gente que "no califica".
          </p>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-124">
          <p className="text-3xl font-serif font-bold text-dark italic" data-id="element-125">
            Hoy termina eso.
          </p>
        </FadeIn>
      </div>
    </section>;
}